import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CopyToClipboard } from "react-copy-to-clipboard";
import UserService from "../services/user.service";
import PassphraseRecoveryconfirm from "./Passphrase-Recovery-confirm-compoent";

class CreateWallet extends Component {
  state = { isdisplaybackupconfirm: false, sess_id: "", loading: true };

  componentDidMount() {
    UserService.CreateWallet()
      .then((response) => {
        if (response.data.code === 100) {
          this.setState({ sess_id: response.data.mnemonic, loading: false });
        } else {
          toast.error(response.data.msg || "Unable to create a wallet.");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        toast.error("Unable to create a wallet. Please try again.");
        this.setState({ loading: false });
      });
  }

  renderHeader() {
    return (
      <header className="nova-create-header">
        <Link to="/" className="nova-wordmark" aria-label="Back to Nova Wallet home">
          <img src="../assets/images/NOVA-1.png" alt="Nova Wallet" />
        </Link>
        <span className="nova-status"><i></i> Wallet setup</span>
      </header>
    );
  }

  render() {
    if (this.props.isLoggedIn) return <Redirect to="/dashboard/VSOL" />;

    const words = this.state.sess_id ? this.state.sess_id.split(" ") : [];
    const confirming = this.state.isdisplaybackupconfirm;

    return (
      <div className="nova-create-page">
        <ToastContainer />
        <div className="nova-auth-glow nova-auth-glow-one" aria-hidden="true"></div>
        <div className="nova-auth-glow nova-auth-glow-two" aria-hidden="true"></div>
        {this.renderHeader()}

        <main className="nova-create-main">
          <div className="nova-create-progress" aria-label="Wallet setup progress">
            <span className="is-complete"><b>1</b><em>Create</em></span>
            <i></i>
            <span className={confirming ? "is-complete" : "is-current"}><b>2</b><em>Back up</em></span>
            <i></i>
            <span className={confirming ? "is-current" : ""}><b>3</b><em>Confirm</em></span>
          </div>

          {!confirming ? (
            <section className="nova-create-card" aria-labelledby="recovery-title">
              <div className="nova-create-title">
                <span className="nova-create-icon nova-vault-glyph" aria-hidden="true">
                  <svg viewBox="0 0 40 40"><path d="M20 4 33 11v9c0 8-5 13-13 16C12 33 7 28 7 20v-9Z"/><path d="m14 20 4 4 8-9"/></svg>
                </span>
                <div>
                  <span className="nova-eyebrow">Your private recovery key</span>
                  <h1 id="recovery-title">Back up these 18 words</h1>
                </div>
              </div>
              <p className="nova-create-lead">Write these words down in order and keep them somewhere private. They are the only way to restore this wallet.</p>

              <div className="nova-warning-strip">
                <span aria-hidden="true">!</span>
                <p><strong>Never share this phrase.</strong> Anyone who has it can access and move your assets.</p>
              </div>

              {this.state.loading ? (
                <div className="nova-phrase-loading"><span className="spinner-border" aria-hidden="true"></span> Generating your secure recovery phrase…</div>
              ) : (
                <div className="nova-word-grid" aria-label="18-word recovery phrase">
                  {words.map((word, index) => (
                    <div className="nova-word" key={index}><span>{index + 1}</span><strong>{word}</strong></div>
                  ))}
                </div>
              )}

              <div className="nova-create-actions">
                <CopyToClipboard text={this.state.sess_id} onCopy={() => toast.success("Recovery phrase copied.") }>
                  <button className="btn nova-copy-button" disabled={!this.state.sess_id} type="button"><span aria-hidden="true">□</span> Copy words</button>
                </CopyToClipboard>
                <button className="btn nova-primary-button" disabled={!this.state.sess_id} type="button" onClick={() => this.setState({ isdisplaybackupconfirm: true })}>
                  I’ve saved my words <span aria-hidden="true">→</span>
                </button>
              </div>
              <p className="nova-offline-note"><span aria-hidden="true">●</span> Store your phrase offline. Nova cannot recover it for you.</p>
            </section>
          ) : (
            <PassphraseRecoveryconfirm mnemonic={this.state.sess_id} history={this.props.history} onBack={() => this.setState({ isdisplaybackupconfirm: false })} />
          )}
        </main>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { isLoggedIn: state.auth.isLoggedIn };
}

export default connect(mapStateToProps)(CreateWallet);
